import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { apiRequest, API_CONSTANTS} from '../libs/apiRequest';
import GoogleButton from 'react-google-button'
import { useNavigate } from 'react-router-dom';
import '../css/gtc-forgot.css';

function GTCForgot() {
    const navigate = useNavigate();
    const login = useGoogleLogin({
        onSuccess: (codeResponse) => {
            console.log(codeResponse);
            handleRequestUserInfo(codeResponse);
        },
        onError: (error) => console.log('Login Failed:', error)
    });

    const handleRequestUserInfo = async (codeResponse) => {
        
        try {

            const form = new FormData();

            Object.keys(codeResponse).map((key) => {
                form.append(key, codeResponse[key]);
            });

            const response = await apiRequest({
                method: "POST",
                api: API_CONSTANTS.PUBLIC_API,
                fn: "verify-credentials",
                data: form
            });
            const data = await response
            console.log("handleRequestUserInfo", data)
            navigate("/");
            window.location.reload();  
        } catch (error) {
            console.log("handleRequestUserInfo", error)
        }
        
    }

    return (
        <div className="forgot-page">
            <div className="forgot-container">
                <div className="forgot-card">
                    <div className="forgot-header">
                        <h1 className="forgot-title">
                            <span style={{ color: "var(--secondary-color)" }}>Go</span>
                            Trycatch
                        </h1>
                        <h2 className="forgot-subtitle">Reset Password</h2>
                        <p className="forgot-description">
                            Enter your email address and we'll send you instructions to reset your password
                        </p>
                    </div>

                    <div className="forgot-form">
                        <div className="form-group">
                            <label className="form-label">Email Address</label>
                            <input 
                                className="form-input"
                                type="email"
                                placeholder="Enter your email address"
                            />
                        </div>

                        <a className="reset-button">
                            Reset Password
                        </a>

                        <p className="info-text">
                            We'll send a password reset link to your email address. 
                            If you don't receive it within a few minutes, please check your spam folder.
                            <br /><br />
                            Remember your password? <a href="/login" className="login-link">Back to Login</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}   

export default GTCForgot;